export default (chain: Array<Function>): any => {
  let result: any = Promise.resolve();
  chain.forEach(task => {
    result = result.then(() => new Promise((r) => task().then(r).catch(r)));
  });
  return result;
};
